import React from "react";
import { RaisedButton } from "material-ui";
import BaseOverlay from "./base.jsx";
import AccountCreation from "../partials/account-creation.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PassStore from "../../stores/PassStore";
import PassActions from "../../actions/PassActions";
import PersonStore from "../../stores/PersonStore";

@connectToStores
class AcceptPassTransferOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.cancel = this.cancel.bind(this);
    this.accept = this.accept.bind(this);
    this.isSundance = this.isSundance.bind(this);
  }

  static get contextTypes() {
    return {
      tenant: React.PropTypes.object,
      router: React.PropTypes.object.isRequired
    };
  }

  static getStores() {
    return [PassStore, PersonStore];
  }

  static getPropsFromStores() {
    let store = PassStore.getState();
    store.isLoggedIn = PersonStore.getState().isLoggedIn;
    return store;
  }

  cancel() {
    if (this.isSundance()) {
      window.location.href = "https://festival.sundance.org";
    }
    else {
      this.context.router.push(`/${this.context.tenant.passes_url_pathname}`);
    }
  }

  accept() {
    PassActions.acceptPassTransfer(
      this.props.location.query.pass,
      this.props.location.query.token
    );
  }

  isSundance() {
    return !!this.context.tenant.sundance_login;
  }

  componentWillReceiveProps(props) {
    // Assume that once the pass is in the user's account, the transfer is successful
    if (props.passes[props.location.query.pass]) {
      this.cancel();
    }
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  render() {
    const isGift = !!this.props.location.query.gift;

    return (
      <BaseOverlay>
        <div style={{ textAlign: "center", fontSize: "11pt" }}>
          <h3>
            {this.context.tenant.memberships_enabled
              ? isGift
                ? `Accept gift ${this.context.tenant.display_membership}`
                : `Accept ${this.context.tenant.display_membership} transfer`
              : isGift
                ? `Accept gift ${this.context.tenant.display_membership}`
                : `Accept ${this.context.tenant.display_membership} transfer`
            }
          </h3>
          {this.props.isLoggedIn ? (
            <div>
              <p>
                To accept the{" "}
                { this.context.tenant.memberships_enabled
                    ? isGift
                      ? `gift ${this.context.tenant.display_membership}`
                      : `${this.context.tenant.display_membership} transfer`
                    : isGift
                      ? `gift ${this.context.tenant.display_pass}`
                      : `${this.context.tenant.display_pass} transfer`
                }
                , just click the button below.
              </p>
              <div style={{ marginTop: 10 }}>
                <RaisedButton
                  label={`Accept ${
                    this.context.tenant.memberships_enabled
                      ? isGift
                        ? `gift ${this.context.tenant.display_membership}`
                        : `${this.context.tenant.display_membership} transfer`
                      : isGift
                      ? `gift ${this.context.tenant.display_pass}`
                      : `${this.context.tenant.display_pass} transfer`
                  }`}
                  primary={true}
                  onClick={this.accept}
                />
                <RaisedButton
                  label="Cancel"
                  style={{ marginLeft: 7 }}
                  onClick={this.cancel}
                />
              </div>
            </div>
          ) : (
            <AccountCreation
              actionVerb={`accept this ${isGift ? "gift" : "transfer"}`}
            />
          )}
        </div>
      </BaseOverlay>
    );
  }
}

export default AcceptPassTransferOverlay;



// WEBPACK FOOTER //
// ./src/app/components/overlays/accept-pass-transfer.jsx